// Allca Weekend collection grid fix
(function() {
  if(window.location.pathname !== '/collections/allca-weekend') return;
  var style = document.createElement('style');
  style.textContent = '.collection__grid-wrapper-hide-on-load{opacity:1!important;visibility:visible!important;overflow:visible!important;height:auto!important;display:block!important;}[aria-busy="true"].js-grid-wrapper{opacity:1!important;visibility:visible!important;}';
  (document.head||document.documentElement).appendChild(style);
  function fix(){var g=document.querySelector('.js-grid-wrapper');if(g){g.classList.remove('collection__grid-wrapper-hide-on-load');g.removeAttribute('aria-busy');}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fix);}else{fix();}
  window.addEventListener('load',fix);
  var t=0,iv=setInterval(function(){fix();if(++t>50)clearInterval(iv);},100);
})();

// Atualização de preço na troca de swatch nos cards de produto.
// Escreve apenas os dados nativos do tema (preço, compare_at, classe on-sale);
// o bloco Allca renderizado pelo price.liquid observa o container e
// recalcula De/PIX/parcelas sozinho.
(function () {
  function formatBRL(cents) {
    var value = cents / 100;
    var intPart = Math.floor(value);
    var decPart = Math.round((value - intPart) * 100);
    var intStr = String(intPart).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var decStr = decPart < 10 ? '0' + decPart : String(decPart);
    return 'R$ ' + intStr + ',' + decStr;
  }

  function initCard(card) {
    var priceDataEl = card.querySelector('.js-variant-prices');
    if (!priceDataEl) return;

    var data;
    try {
      data = JSON.parse(priceDataEl.textContent);
    } catch (e) {
      return;
    }

    function updatePrice(variantId) {
      var variant = data.variants.find(function (v) { return v.id == variantId; });
      if (!variant) return;

      var isOnSale = variant.compare_at_price > variant.price;

      card.querySelectorAll('[data-product-price]').forEach(function (el) {
        el.textContent = formatBRL(variant.price);
        el.setAttribute('data-amount', variant.price);
      });

      var priceOldEl = card.querySelector('[data-price-old]');
      if (priceOldEl) {
        priceOldEl.textContent = isOnSale ? formatBRL(variant.compare_at_price) : '';
      }

      var priceContainer = card.querySelector('.js-price');
      if (priceContainer) {
        priceContainer.classList.toggle('price--on-sale', isOnSale);
      }

      var fromLabel = card.querySelector('.price-from-label');
      if (fromLabel) {
        fromLabel.style.display = 'none';
      }
    }

    function updateFromSwatchName(swatchName) {
      var wrappers = Array.from(card.querySelectorAll('[data-image]'));
      var wrapper = wrappers.find(function (w) { return w.dataset.image === swatchName; });
      if (wrapper && wrapper.dataset.variant) updatePrice(wrapper.dataset.variant);
    }

    // Exibição inicial: usa is-active se existir, senão usa o primeiro wrapper
    var activeWrapper = card.querySelector('[data-image].is-active')
                     || card.querySelector('[data-image]');
    if (activeWrapper && activeWrapper.dataset.variant) {
      updatePrice(activeWrapper.dataset.variant);
    }

    // Botões de swatch (.js-product-card-swatch) — o tema ouve clique/hover neles
    card.querySelectorAll('.js-product-card-swatch').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        updateFromSwatchName(this.dataset.swatch);
      });
      btn.addEventListener('click', function () {
        updateFromSwatchName(this.dataset.swatch);
      });
    });

    // MutationObserver: fallback para quando o tema adiciona is-active ao wrapper
    var observer = new MutationObserver(function () {
      var active = card.querySelector('[data-image].is-active');
      if (active && active.dataset.variant) updatePrice(active.dataset.variant);
    });
    card.querySelectorAll('[data-image]').forEach(function (wrapper) {
      observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-product-card').forEach(initCard);
  });
})();
